const EditorRightArrow = () => {
  return (
    <svg
      aria-hidden="true"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
      version="1.1"
      width="24"
      data-view-component="true"
      className="octicon octicon-chevron-right color-fg-muted"
    >
      <path d="M8.72 18.78a.75.75 0 0 1 0-1.06L14.44 12 8.72 6.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018l6.25 6.25a.75.75 0 0 1 0 1.06l-6.25 6.25a.75.75 0 0 1-1.06 0Z" />
    </svg>
  );
};

export default EditorRightArrow;
